import { Injectable } from '@angular/core';
import { AppData } from 'src/app/shared/services/app-data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiRequestService } from 'src/app/shared/services/api-request.service';
import { preCheckoutReqObj } from 'src/app/shared/utils/menu-cart-item-functions';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  closeLoginModal: any; // method variable

  constructor(private apiRequestService: ApiRequestService,
    private router: Router, private activatedRoute: ActivatedRoute,private navCtrl:NavController) { }

  init(onCloseLoginModal) {
    this.closeLoginModal = onCloseLoginModal;
  }

  sendOtp(reqBody) {
    return this.apiRequestService.post('sendOtp', reqBody);
  }

  reSendOtp(reqBody) {
    return this.apiRequestService.post('reSendOtp', reqBody, '', '?method=resendOtp');
  }

  signUp(reqBody) {
    return this.apiRequestService.post('signUp', reqBody);
  }

  verifyOtp(reqBody) {
    return this.apiRequestService.post('verifyOtp', reqBody);
  }

  addReferralCode(reqBody) {
    return this.apiRequestService.post('referralCode', reqBody, {}, '?userId=' + AppData.userId);
  }

  exploreFirst(reqBody) {
    return this.apiRequestService.post('exploreFirst', reqBody);
  }
  async preCheckout() {
    const reqBody = await preCheckoutReqObj();
    return this.apiRequestService.post("preOrderCheckout", reqBody);
  }

  saveUserDataInLocal(responseData, routeObj) {
    AppData.isAuthenticated = true;
    AppData.token.next(responseData.token);
    AppData.userInfoSub$.next(responseData.user);
    AppData.userIdSub$.next(responseData.user.userId);
    AppData.cartIdSub$.next(responseData.user.cartId);
    // this.closeLoginModal();
    if (responseData.user.isTemporary) {
      AppData.isTemporarySub$.next(true);
    } else {
      AppData.isTemporarySub$.next(false);
    }

    if (routeObj.navigateToAccount && routeObj.navigateToAccount === 'true') {
      this.navCtrl.navigateForward(['/account']);
    } else if (routeObj.navigateToCart && routeObj.navigateToCart === 'Y') {
      this.navCtrl.navigateRoot(['/cart']);
    } else if (routeObj.fromHome && routeObj.fromHome === 'Y') {
      this.navCtrl.navigateRoot(['refer-earn'], { queryParams: { navigateToHome: 'Y' } });
    } else {
      this.navCtrl.navigateRoot(['select-location'], { queryParams: { redirectUrl: window.location.pathname } })
    }

    // console.log(AppData.currentAddressObj)
  }

    // if (AppData.currentAddressObj) {
    //   this.router.navigate(['/home']);
    // } else {
    // }
}
